import React, { useEffect } from "react";
import { Button } from "../../../common/commonIndex";

const Eligibility = ({ handleNextEvent, formData }) => {

    useEffect(() => {
        console.log('inner height', window.innerHeight);
    });

    // Handle form submission
    const handleSubmit = (e) => {
        // e.preventDefault();
        handleNextEvent(1);
    };

    return (
        <div>
            <div className={` ${window.innerHeight < 576 ? 'scrollbar eligibility-scrollbar' : ''}`}>
                <div className={` ${window.innerHeight < 576 ? 'force-overflow' : ''}`}>
                    <div className="eligibility questionnaire">
                        <h3 className="title">Eligibility for Open Access</h3>
                        <p className="description">
                            GutCheck allows healthy, 45 to 74 year olds to conveniently schedule a screening colonoscopy without an initial office visit. This saves you time away from work/home, and the expense of an office co-pay.
                        </p>
                        <p className="description">
                            Open access colonoscopy is not for everyone. Individuals experiencing significant digestive symptoms, have a history of heart disease, breathing or kidney problems are advised to schedule a doctor’s visit prior to the colonoscopy.
                        </p>
                        <p className="description">
                            Your answers to the following questionnaire will be carefully reviewed by staff to see if you qualify for open access or require an office visit before the procedure. The review process may require a phone call to clarify your responses.
                        </p>
                        <p className="description">
                            Your requested procedure date and time will be held until your answers are reviewed.
                        </p>
                    </div>
                </div>
            </div>
            <div className="questionnaire-fix-btn eligibility-fix-btn">
                <div className="divider "></div>
                <div className="footer-content">
                    <div className="skip-eligibility">
                        <a href="#" className="link" onClick={handleSubmit}>Skip for now</a>
                    </div>
                    <Button
                        btnClass={'btn-primary question-btn'}
                        btnType={'button'}
                        btnName={'Continue'}
                        onClick={handleSubmit}
                        isDisabled={true}
                    />
                </div>
            </div>
        </div>
    )
};

export default Eligibility;